import { subscribe } from '../../common/errors/sagas';
import { notificationError } from '../../common/errors/notificationTypes';

const pre = 'FILEAVAILABILITY/';

export const SET_GRID_SORTS = `${pre}SET_GRID_SORTS`;

export const SET_DEFAULT_FILTERS = `${pre}SET_DEFAULT_FILTERS`;
export const SET_RUNDATE = `${pre}SET_RUNDATE`;
export const SET_DATE_TO = `${pre}SET_DATE_TO`;
export const SET_DATE_FROM = `${pre}SET_DATE_FROM`;

export const FILE_AVAILABILITY_LOADED = `${pre}FILE_AVAILABILITY_LOADED`;
export const SET_FILE_AVAILABILITY_LOADING = `${pre}SET_FILE_AVAILABILITY_LOADING`;
export const SET_FILE_AVAILABILITY_INITIALISED = `${pre}SET_FILE_AVAILABILITY_INITIALISED`;
export const GET_FILE_AVAILABILITY = `${pre}GET_FILE_AVAILABILITY`;
export const GET_FILE_AVAILABILITY_SUCCESS = `${pre}GET_FILE_AVAILABILITY_SUCCESS`;
export const GET_FILE_AVAILABILITY_FAILED = `${pre}GET_FILE_AVAILABILITY_FAILED`;
export const REFRESH_FILE_AVAILABILITY = `${pre}REFRESH_FILE_AVAILABILITY`;
subscribe(GET_FILE_AVAILABILITY_FAILED, 'There was an error retrieving the files in the database', notificationError);

export const setGridSorts = (gridId, sorting) => ({
    type: SET_GRID_SORTS,
    gridId,
    sorting
});
export const fileAvailabilityConnected = search => ({
    type: FILE_AVAILABILITY_LOADED,
    search
});

export const setFileAvailabilityLoading = loading => ({
    type: SET_FILE_AVAILABILITY_LOADING,
    loading
});

export const setFileAvailabilityInitialised = initialised => ({
    type: SET_FILE_AVAILABILITY_INITIALISED,
    initialised
});

export const getFileAvailability = () => ({
    type: GET_FILE_AVAILABILITY
});

export const getFileAvailabilitySuccess = result => ({
    type: GET_FILE_AVAILABILITY_SUCCESS,
    result
});

export const getFileAvailabilityFailed = error => ({
    type: GET_FILE_AVAILABILITY_FAILED,
    error
});

export const refreshFileAvailability = () => ({
    type: REFRESH_FILE_AVAILABILITY    
});

export const setDefaultFilters = filters => ({
    type: SET_DEFAULT_FILTERS,
    filters
});

export const setRunDate = date => ({
    type: SET_RUNDATE,
    date
});
export const setDateFrom = date => ({
    type: SET_DATE_FROM,
    date
});
export const setDateTo = date => ({
    type: SET_DATE_TO,
    date
});


